export default __webpack_public_path__ + "static/media/network.9a668158.svg";